import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import { JazelAppConfig } from '@jazel/jazel-vuetify'
import { config } from './config/generated-config'

const app = createApp(App)

app.use(createPinia())
app.use(vuetify)
app.use(JazelAppConfig, {
  productId: 'aie_descriptions',
  isEmbedded: document.getElementById('aie-descriptions-admin')?.parentNode !== document.body,
  cdnUrl: config.VITE_CDN_URL,
  jamsFrontendUrl: config.VITE_JAMS_FRONTEND_URL,
  jamsBackendUrl: config.VITE_JAMS_BACKEND_URL,
})
app.mount('#aie-descriptions-admin')
